import { Spacer, Spinner, Text } from '@percent/lemonade'
import styled from 'styled-components'
import { RecentDonationsListProps } from './recent-donations-list.types'

const StyledRecentDonationsTitle = styled.p`
  ${({ theme }) => `
      margin: 0;
      font-size: ${theme.fontSizes.bodyLarge};
      font-weight: 600;
      line-height: 32px;
      color: ${theme.colors.black};
    `}
`

const StyledRecentDonationsList = styled.ul`
  ${() => `
      margin: 0 0 16px;
      padding: 0;
      list-style-type: none;
    `}
`

const StyledLoadMoreButton = styled.button`
  ${({ theme }) => `
      margin-right: 20px;
      padding: 6px 0;
      border: none;
      background: transparent;
      cursor: pointer;
      text-decoration: underline;
      font-size: ${theme.fontSizes.bodySmall};
      line-height: 20px;
      letter-spacing: 0.5px;
      color: ${theme.colors.black};

      &:disabled {
        cursor: default;
        color: ${theme.colors.gray500};
      }
    `}
`

const StyledRecentDonationsError = styled.p`
  ${({ theme }) => `
      color: ${theme.colors.gray500};
  `}
`

const StyledShowMore = styled.div`
  display: flex;
  align-items: center;
`

const StyledRecentDonations = styled.div`
  @media only screen and (max-width: 768px) {
    margin-bottom: 48px;
  }
`

export function RecentDonationsList({
  loadMore,
  isLoading,
  showLoadMore,
  hasError,
  children,
  translations,
  totalDonations,
}: Readonly<RecentDonationsListProps>) {
  const {
    seeMoreText,
    totalDonationText,
    noDonationText,
    errorText,
    recentDonationsAriaLabel = 'recent donations',
  } = translations

  const isEmpty = totalDonations === 0

  if (hasError) {
    return (
      <div>
        <StyledRecentDonationsError>{errorText}</StyledRecentDonationsError>
      </div>
    )
  }

  return (
    <StyledRecentDonations>
      <StyledRecentDonationsTitle>
        {totalDonationText}
      </StyledRecentDonationsTitle>
      <Spacer size={4} axis="vertical" />
      {isEmpty ? (
        <Text>{noDonationText}</Text>
      ) : (
        <>
          <StyledRecentDonationsList aria-label={recentDonationsAriaLabel}>
            {children}
          </StyledRecentDonationsList>
          <StyledShowMore>
            {isLoading ? (
              <Spinner size="m" />
            ) : (
              showLoadMore && (
                <StyledLoadMoreButton type="button" onClick={loadMore}>
                  {seeMoreText}
                </StyledLoadMoreButton>
              )
            )}
          </StyledShowMore>
        </>
      )}
    </StyledRecentDonations>
  )
}
